import { render, staticRenderFns } from "./procedure-card.vue?vue&type=template&id=f06e5dda&scoped=true&"
import script from "./procedure-card.vue?vue&type=script&lang=js&"
export * from "./procedure-card.vue?vue&type=script&lang=js&"
import style0 from "./procedure-card.vue?vue&type=style&index=0&id=f06e5dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06e5dda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
